import title from './title.js';

export default dsf.component({
  name: 'DsfTitle5',
  mixins: [title],
  ctrlCaption: "五级标题",
  props: {
    value: {
      type: [String, Number],
      default: '标题5'
    },
    fontType: {
      type: Number,
      default: 5
    }
  }
});